<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">保险目的</div>
		<case-form :schema="schemaPurpose" class="mb6" />

		<div class="fs4 fw7 lh125 mt6 mb2">业务类型</div>
		<case-form :schema="schemaTypeOfBusiness" class="mb6" />

		<div class="fs4 fw7 lh125 mt6 mb2">一般资料</div>
		<case-form :schema="schemaGeneralData" class="mb6" />

		<div class="fs4 fw7 lh125 mt6 mb2">资产负债表</div>

		<j-accordion
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span cclass="fs4 fw7 lh125 mt6 mb2">上年度</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaBalanceSheetCurrent" :isBoxed="false" />
			</div>
		</j-accordion>

		<j-accordion
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span cclass="fs4 fw7 lh125 mt6 mb2">本年度</span>
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaBalanceSheetLastYear" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: `企业名称`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessNameCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessNameCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "企业地址企业地址",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0insuranceRelatedToBusinessAddressCN",
					props: {
						suggest: {
							typeIncludes: "insuranceRelatedToBusinessAddressCN"
						},
						createOptions: {
							type: "insuranceRelatedToBusinessAddressCN"
						}
					}
				},
				{
					label: `邮寄地址，如有不同`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessMailingAddressCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessMailingAddressCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessMailingAddressCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `商业电话号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessTelephoneNoCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessTelephoneNoCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessTelephoneNoCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `商业传真号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessFaxNoCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessFaxNoCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessFaxNoCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `业务性质`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessNatureCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessNatureCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessNatureCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `企业网站`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessWebsiteAddressCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessWebsiteAddressCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessWebsiteAddressCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPurpose() {
			return [
				{
					label: `主要成员`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeKeyPersonCN`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeKeyPersonCN`
						},
						createOptions: {
							type: `hasPurposeKeyPersonCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `信贷保额`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeCreditCoverageCN`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeCreditCoverageCN`
						},
						createOptions: {
							type: `hasPurposeCreditCoverageCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `递延补偿`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeDeferredCompensationCN`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeDeferredCompensationCN`
						},
						createOptions: {
							type: `hasPurposeDeferredCompensationCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `其他`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeOtherCN`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeOtherCN`
						},
						createOptions: {
							type: `hasPurposeOtherCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `其他（请说明）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPurposeOtherDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `hasPurposeOtherDetailsCN`
						},
						createOptions: {
							type: `hasPurposeOtherDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTypeOfBusiness() {
			return [
				{
					label: `独资经营`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeSoleProprietorshipCN`,
					props: {
						suggest: {
							typeIncludes: `hasTypeSoleProprietorshipCN`
						},
						createOptions: {
							type: `hasTypeSoleProprietorshipCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `公司`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeCorporationCN`,
					props: {
						suggest: {
							typeIncludes: `hasTypeCorporationCN`
						},
						createOptions: {
							type: `hasTypeCorporationCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `一般`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeGeneralCN`,
					props: {
						suggest: {
							typeIncludes: `hasTypeGeneralCN`
						},
						createOptions: {
							type: `hasTypeGeneralCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `有限`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeLimitedCN`,
					props: {
						suggest: {
							typeIncludes: `hasTypeLimitedCN`
						},
						createOptions: {
							type: `hasTypeLimitedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `有限`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypeLLCCN`,
					props: {
						suggest: {
							typeIncludes: `hasTypeLLCCN`
						},
						createOptions: {
							type: `hasTypeLLCCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `经营范围`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTypePartnershipCN`,
					props: {
						suggest: {
							typeIncludes: `hasTypePartnershipCN`
						},
						createOptions: {
							type: `hasTypePartnershipCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaGeneralData() {
			return [
				{
					label: `职务`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessPositionCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessPositionCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessPositionCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `薪资（美元）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessSalaryCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessSalaryCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessSalaryCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `工作时长`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessLengthOfServiceCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessLengthOfServiceCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessLengthOfServiceCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `奖金（美元）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessBonusCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessBonusCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessBonusCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `持股比例`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0insuranceRelatedToBusinessOwnershipCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceRelatedToBusinessOwnershipCN`
						},
						createOptions: {
							type: `insuranceRelatedToBusinessOwnershipCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `其他公司要员是否也购买了保险?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0areOtherKeyEmployeesInsuredCN`,
					props: {
						suggest: {
							typeIncludes: `areOtherKeyEmployeesInsuredCN`
						},
						createOptions: {
							type: `areOtherKeyEmployeesInsuredCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `详情`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherKeyEmployeesInsuredDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `otherKeyEmployeesInsuredDetailsCN`
						},
						createOptions: {
							type: `otherKeyEmployeesInsuredDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `您是否曾宣布破产？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDeclaredForBankruptcyCN`,
					props: {
						suggest: {
							typeIncludes: `hasDeclaredForBankruptcyCN`
						},
						createOptions: {
							type: `hasDeclaredForBankruptcyCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaBalanceSheetCurrent() {
			return [
				{
					label: `资产 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementAssetsCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementAssetsCN`
						},
						createOptions: {
							type: `financialStatementAssetsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `净值 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementNetWorthCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementNetWorthCN`
						},
						createOptions: {
							type: `financialStatementNetWorthCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `毛收入 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementGrossIncomeCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementGrossIncomeCN`
						},
						createOptions: {
							type: `financialStatementGrossIncomeCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `负债 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementLiabilitiesCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementLiabilitiesCN`
						},
						createOptions: {
							type: `financialStatementLiabilitiesCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `市值 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementMarketValueCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementMarketValueCN`
						},
						createOptions: {
							type: `financialStatementMarketValueCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `净收入 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementNetIncomeCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementNetIncomeCN`
						},
						createOptions: {
							type: `financialStatementNetIncomeCN`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaBalanceSheetLastYear() {
			return [
				{
					label: `资产 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementAssetsLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementAssetsLastYearCN`
						},
						createOptions: {
							type: `financialStatementAssetsLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `净值 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementNetWorthLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementNetWorthLastYearCN`
						},
						createOptions: {
							type: `financialStatementNetWorthLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `净值 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementGrossIncomeLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementGrossIncomeLastYearCN`
						},
						createOptions: {
							type: `financialStatementGrossIncomeLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `负债 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementLiabilitiesLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementLiabilitiesLastYearCN`
						},
						createOptions: {
							type: `financialStatementLiabilitiesLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `市值 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementMarketValueLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementMarketValueLastYearCN`
						},
						createOptions: {
							type: `financialStatementMarketValueLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `净收入 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0financialStatementNetIncomeLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `financialStatementNetIncomeLastYearCN`
						},
						createOptions: {
							type: `financialStatementNetIncomeLastYearCN`,
							dataType: "number"
						}
					}
				}
			]
		}
	}
}
</script>
